import { PAGE_HISTORY_DEPTH } from '@/constants/common';

export const checkLocalRouting = (): boolean => {
  if (typeof window === 'undefined') return false;
  return !(window.history.length <= PAGE_HISTORY_DEPTH);
};
